// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sup-rectangle1{
  width: 997px;
  height: 419px;
  margin-top: 90px;
  margin-left: 18px;
  border-radius: 20px;
  background: linear-gradient(226.86deg, rgba(79, 121, 158, 0.05) 0%, rgba(113, 119, 124, 0.036612) 81.39%, rgba(170, 170, 170, 0.0015) 98.91%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(53, 53, 53, 0.199);

}
.sup-rectangle2{
 width: 997px;
 height: 42px;
 background: #014D4E;
 margin-top: -370px;
 text-align: center; 
 border-radius: 20px 20px 0 0;
  
}

.dropdown-container {
  width: 200px;
  padding: 30px;
}

.mb-4 {
  margin-bottom: 16px;
}

.sup-rectangle1 {
  width: 997px;
  height: 419px;
  margin-top: 90px;
  margin-left: 18px;
  border-radius: 20px;
  background: linear-gradient(226.86deg, rgba(79, 121, 158, 0.05) 0%, rgba(113, 119, 124, 0.036612) 81.39%, rgba(170, 170, 170, 0.0015) 98.91%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(53, 53, 53, 0.199);
}

.sup-rectangle2 {
  width: 997px;
  height: 42px;
  background: #014D4E;
  margin-top: -370px;
  text-align: center; 
  border-radius: 20px 20px 0 0;
}

.dropdown-container {
  width: 200px;
  padding: 30px;
}

.mb-4 {
  margin-bottom: 16px;
}

.mb-5 {
  margin-bottom: 20px;
}

.filter-popover-content {
  width: 250px;
  padding: 16px;
}

.filter-section {
  margin-bottom: 16px;
}

.filter-dropdown-btn {
  border: none;
  background: none;
  display: flex;
  align-items: center;
  color: #1F405A;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 0;
}

.supplier-input {
  width: 100%;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}

.filter-btn-container {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.apply-filter-btn {
  width: 100px;
  background-color: rgba(31, 64, 90, 0.1);
  color: #1F405A;
  border: none;
  border-radius: 4px;
  height: 32px;
  font-weight: 500;
}

.apply-filter-btn:hover {
  background-color: #1F405A;
  color: white;
}

.filter-popover .ant-popover-inner-content {
  padding: 0;
}

.filter-popover {
  position: fixed;
  z-index: 1000;
}

.filter-icon-active {
  background-color: rgba(46, 158, 198, 0.1);
  border-radius: 50%;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.filter-popover .ant-popover-inner-content {
  border: 2px solid #2C5778;
  border-radius: 8px;
  padding: 16px;
}

.filter-section {
  margin-bottom: 16px;
}

.filter-dropdown-btn {
  width: 100%;
  text-align: left;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.apply-filter-btn {
  background-color: #1F405A;
  color: white;
  border: none;
  border-radius: 4px;
  width: 100%;
}

.filter-popover {
  min-width: 240px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Admin/AdminDashBoard.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,6IAA6I;EAC7I,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,+CAA+C;;AAEjD;AACA;CACC,YAAY;CACZ,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,4BAA4B;;AAE7B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,6IAA6I;EAC7I,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".sup-rectangle1{\n  width: 997px;\n  height: 419px;\n  margin-top: 90px;\n  margin-left: 18px;\n  border-radius: 20px;\n  background: linear-gradient(226.86deg, rgba(79, 121, 158, 0.05) 0%, rgba(113, 119, 124, 0.036612) 81.39%, rgba(170, 170, 170, 0.0015) 98.91%);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 4px rgba(53, 53, 53, 0.199);\n\n}\n.sup-rectangle2{\n width: 997px;\n height: 42px;\n background: #014D4E;\n margin-top: -370px;\n text-align: center; \n border-radius: 20px 20px 0 0;\n  \n}\n\n.dropdown-container {\n  width: 200px;\n  padding: 30px;\n}\n\n.mb-4 {\n  margin-bottom: 16px;\n}\n\n.sup-rectangle1 {\n  width: 997px;\n  height: 419px;\n  margin-top: 90px;\n  margin-left: 18px;\n  border-radius: 20px;\n  background: linear-gradient(226.86deg, rgba(79, 121, 158, 0.05) 0%, rgba(113, 119, 124, 0.036612) 81.39%, rgba(170, 170, 170, 0.0015) 98.91%);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 4px rgba(53, 53, 53, 0.199);\n}\n\n.sup-rectangle2 {\n  width: 997px;\n  height: 42px;\n  background: #014D4E;\n  margin-top: -370px;\n  text-align: center; \n  border-radius: 20px 20px 0 0;\n}\n\n.dropdown-container {\n  width: 200px;\n  padding: 30px;\n}\n\n.mb-4 {\n  margin-bottom: 16px;\n}\n\n.mb-5 {\n  margin-bottom: 20px;\n}\n\n.filter-popover-content {\n  width: 250px;\n  padding: 16px;\n}\n\n.filter-section {\n  margin-bottom: 16px;\n}\n\n.filter-dropdown-btn {\n  border: none;\n  background: none;\n  display: flex;\n  align-items: center;\n  color: #1F405A;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 8px 0;\n}\n\n.supplier-input {\n  width: 100%;\n  height: 32px;\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n}\n\n.filter-btn-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n}\n\n.apply-filter-btn {\n  width: 100px;\n  background-color: rgba(31, 64, 90, 0.1);\n  color: #1F405A;\n  border: none;\n  border-radius: 4px;\n  height: 32px;\n  font-weight: 500;\n}\n\n.apply-filter-btn:hover {\n  background-color: #1F405A;\n  color: white;\n}\n\n.filter-popover .ant-popover-inner-content {\n  padding: 0;\n}\n\n.filter-popover {\n  position: fixed;\n  z-index: 1000;\n}\n\n.filter-icon-active {\n  background-color: rgba(46, 158, 198, 0.1);\n  border-radius: 50%;\n  padding: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.filter-popover .ant-popover-inner-content {\n  border: 2px solid #2C5778;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.filter-section {\n  margin-bottom: 16px;\n}\n\n.filter-dropdown-btn {\n  width: 100%;\n  text-align: left;\n  padding: 8px 12px;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  background-color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.apply-filter-btn {\n  background-color: #1F405A;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  width: 100%;\n}\n\n.filter-popover {\n  min-width: 240px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
